__webpack_require__.p = "/Frontend-Mentor---Interactive-rating-component-solution/";